import FarmsTable from '../components/farm/FarmsTable';
import { getFirstQueryResult } from '../utils/graphql';
import { useQueryWithMsg } from '../utils/hooks';
import { searchBy } from '../utils/search';

const FarmsView = ({ query, ...props }) => {
  const { msg, data } = useQueryWithMsg(query, {
    fetchPolicy: 'cache-and-network',
  });
  return (
    <FarmsTable
      farms={getFirstQueryResult(data)}
      msg={msg}
      searchable
      search={searchBy(['name', 'team.name'])}
      {...props}
    />
  );
};

export default FarmsView;
